/* eslint-disable react/prefer-stateless-function */
import React, { useEffect } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { selectTasksCountStat } from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import { t } from 'utils/translates';

const MyTasksNav = props => {
  useEffect(() => {
    // eslint-disable-next-line no-undef
    $(`#panelGroupMenu_c_3`).collapse(props.isOpen ? 'show' : 'hide');
  }, [props.isOpen]);

  const tasksExecsStatByAccTasks =
    props.countsTasksStat.tasksExecsStatByAccTasks;
  const execActiveCount =
    tasksExecsStatByAccTasks.countExecRemake +
    tasksExecsStatByAccTasks.countExecAtCheckout +
    tasksExecsStatByAccTasks.countExecProcessed +
    tasksExecsStatByAccTasks.countExecDispute;
  return (
    <div className="panel panel-default">
      <div className="panel-heading" role="tab" id="panelGroupMenu_h_3">
        <a
          className="dropdown-toggle dropdown-toggle-collapse collapsed"
          role="button"
          data-toggle="collapse"
          data-parent="#panelGroupMenu"
          href={null}
          aria-expanded="false"
          aria-controls="panelGroupMenu_c_3"
          title={t('Мои заказы')}
          onClick={props.onToggle}
        >
          <i className="fa fa-check-square-o fa-lg fa-fw" aria-hidden="true" />{' '}
          {t('Мои заказы')}
        </a>
      </div>
      <div
        id="panelGroupMenu_c_3"
        className={'panel-collapse collapse'}
        role="tabpanel"
        aria-labelledby="panelGroupMenu_h_3"
      >
        <div className="list-group">
          <NavLink
            to="/my-tasks/all-tasks"
            activeClassName="active"
            className="list-group-item"
          >
            <span className="badge">{props.countsTasksStat.countMyTasks}</span>{' '}
            <span className="list-group-item-val">{t('Все заказы')}</span>
          </NavLink>
          <NavLink
            to="/my-tasks/active-tasks"
            activeClassName="active"
            className="list-group-item"
          >
            <span className="badge">
              {props.countsTasksStat.myTasksStat.countActive}
            </span>{' '}
            <span className="list-group-item-val">{t('Активные заказы')}</span>
          </NavLink>
          <NavLink
            to="/my-tasks/stopped-tasks"
            activeClassName="active"
            className="list-group-item"
          >
            <span className="badge">
              {props.countsTasksStat.myTasksStat.countStopped}
            </span>{' '}
            <span className="list-group-item-val">
              {t('Остановленные заказы')}
            </span>
          </NavLink>
          <NavLink
            to="/my-tasks/finished-tasks"
            activeClassName="active"
            className="list-group-item"
          >
            <span className="badge">
              {props.countsTasksStat.myTasksStat.countFinished}
            </span>{' '}
            <span className="list-group-item-val">
              {t('Завершенные заказы')}
            </span>
          </NavLink>
          <NavLink
            to="/my-tasks/archived-tasks"
            activeClassName="active"
            className="list-group-item"
          >
            <span className="badge">
              {props.countsTasksStat.myTasksStat.countArchive}
            </span>{' '}
            <span className="list-group-item-val">{t('Архивные заказы')}</span>
          </NavLink>
          <NavLink
            to="/my-tasks/premoderation"
            activeClassName="active"
            className="list-group-item"
          >
            <span className="badge">
              {props.countsTasksStat.myTasksStat.countPremoderation}
            </span>{' '}
            <span className="list-group-item-val">
              <i className="fa fa-eye" aria-hidden="true" />{' '}
              {t('На премодерации')}
            </span>
          </NavLink>
          <NavLink
            to="/my-tasks/on-correction"
            activeClassName="active"
            className="list-group-item"
          >
            <span className="badge">
              {props.countsTasksStat.myTasksStat.countOnCorrection}
            </span>{' '}
            <span className="list-group-item-val">
              <i className="fa fa-pencil-square-o" aria-hidden="true" />{' '}
              {t('Требует корректировки')}
            </span>
          </NavLink>
          <NavLink
            to="/my-tasks/locked-tasks"
            activeClassName="active"
            className="list-group-item"
          >
            <span className="badge">
              {props.countsTasksStat.myTasksStat.countLocked}
            </span>{' '}
            <span className="list-group-item-val">
              <i className="fa fa-ban" aria-hidden="true" />{' '}
              {t('Заблокировано')}
            </span>
          </NavLink>
          <NavLink
            to="/my-tasks/executions"
            activeClassName="active"
            className="list-group-item border-t border-dashed"
          >
            <span className="badge">{execActiveCount}</span>{' '}
            <span className="list-group-item-val text-overflow">
              <i className="fa fa-play-circle-o" aria-hidden="true" />{' '}
              {t('Выполнения')}
            </span>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

MyTasksNav.defaultProps = {
  isOpen: false,
  onToggle: () => {}
};

MyTasksNav.propTypes = {
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func,
  countsTasksStat: PropTypes.shape({
    countMyTasks: PropTypes.number.isRequired,
    countExecutionsMyTasks: PropTypes.number.isRequired,
    myTasksStat: PropTypes.shape({
      countActive: PropTypes.number.isRequired,
      countStopped: PropTypes.number.isRequired,
      countFinished: PropTypes.number.isRequired,
      countArchive: PropTypes.number.isRequired,
      countLocked: PropTypes.number.isRequired,
      countPremoderation: PropTypes.number.isRequired,
      countOnCorrection: PropTypes.number.isRequired
    }),
    tasksExecsStatByAccTasks: PropTypes.shape({
      countExecProcessed: PropTypes.number.isRequired,
      countExecAtCheckout: PropTypes.number.isRequired,
      countExecRemake: PropTypes.number.isRequired,
      countExecDispute: PropTypes.number.isRequired
    }).isRequired
  }).isRequired
};

const mapStateToProps = state => ({
  countsTasksStat: selectTasksCountStat(state)
});

export default withRouter(connect(mapStateToProps)(MyTasksNav));



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Sidebar/Navs/MyTasksNav.js